export const PAYMENT_IN_PROGRESS_TEXT =
  "We haven't received a confirmation from your payment provider yet. Your campaign will start as soon as the payment is confirmed."

export const PAYMENT_FAILED_TEXT =
  "We couldn't complete your payment. This may be due to insufficient funds or another issue with your payment method. Please try a different payment method to start your campaign."
